import { BrowserRouter, Route } from 'react-router-dom';

import Cart from 'cart/CartAppLoader';
import CheckoutAppLoader from 'checkout/CheckoutAppLoader';
import ClubSignupRedirect from 'club/ClubSignupRedirect';
import ClubList from 'club/List';
import ClubSignup from 'clubSignup/ClubSignupAppLoader';
import {
  getProfileBase,
  getProductBase,
  getReservationBase,
  getCheckoutBase,
  getCollectionBase,
  getCartBase,
  getClubBase
} from 'common/helpers/routerHelper';
import Collection from 'products/CollectionLoader';
import Product from 'products/ProductLoader';
import ProfileAppLoader from 'profile/ProfileAppLoader';
import ReservationAppLoader from 'reservation/ReservationAppLoader';
import ReservationTypeAppLoader from 'reservation/ReservationTypeAppLoader';
import ReservationCartAppLoader from 'reservationCart/ReservationCartAppLoader';

import ScrollToTop from './common/components/routes/ScrollToTop';
import URLHistory from './common/components/routes/UrlHistory';

const BrowserRoutes = () => (
  <BrowserRouter>
    <Route exact={false} path={getCartBase()} component={Cart} />
    <Route
      exact={false}
      path={`${getCheckoutBase()}/cart`}
      component={CheckoutAppLoader}
    />
    <Route
      exact={false}
      path={`${getCheckoutBase()}/club`}
      component={ClubSignup}
    />
    <Route
      exact={false}
      path={`${getCheckoutBase()}/reservation`}
      component={ReservationCartAppLoader}
    />
    <Route exact path={getClubBase()} component={ClubList} />
    <Route
      exact={false}
      path={`${getClubBase()}/:slug`}
      component={ClubSignupRedirect}
    />
    <Route
      exact={false}
      path={`${getCollectionBase()}/:slug`}
      component={Collection}
    />
    <Route
      exact={false}
      path={`${getProductBase()}/:slug`}
      component={Product}
    />
    <Route exact={false} path={getProfileBase()} component={ProfileAppLoader} />
    <Route exact path={getReservationBase()} component={ReservationAppLoader} />
    <Route
      exact={false}
      path={`${getReservationBase()}/type/:slug`}
      component={ReservationTypeAppLoader}
    />
    <ScrollToTop />
    <URLHistory />
  </BrowserRouter>
);

export default BrowserRoutes;
